export class GeneralError {
    constructor(code, message) {
      this.code = code;
      this.message = message;
    }
  }
  